import { request } from "../utils/request.js"

// 修改系统配置项的值
export const sysConfig_updateValue = (pojo, args) => request({
    url: 'sysConfig/updateValue',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

// 批量修改系统配置项的值
export const sysConfig_updateValueBatch = (pojo, args) => request({
    url: 'sysConfig/updateValueBatch',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

// 通过code获取系统配置项
export const sysConfig_findByCode = (id, args) => request({
    url: 'sysConfig/findByCode',
    method: 'GET',
    params: { id },
    showFailMessage: true,
    ...args
})

// 通过code获取系统配置项清单
export const sysConfig_findByCodeIn = (pojo, args) => request({
    url: 'sysConfig/findByCodeIn',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})


// WEBPACK FOOTER //
// ./src/api/sysConfig.js